import PolicyPage from "./PolicyPage";

export default function CookiePolicy() {
  return (
    <PolicyPage
      slug="cookies"
      title="Cookie Policy"
      intro="This policy explains how Fire Safety Systems uses cookies and similar technologies on this website."
      sections={[
        {
          h: "What are cookies",
          p: [
            "Cookies are small text files placed on your device by websites you visit. They are widely used to make websites work, or to work more efficiently, as well as to provide information to site owners.",
          ],
        },
        {
          h: "How we use cookies",
          p: [
            "We use a small number of essential cookies to keep this website functional. Where we use analytics, we do so to understand how the site is used and to improve the experience for visitors.",
          ],
        },
        {
          h: "Managing cookies",
          p: [
            "You can control and delete cookies through your browser settings. Disabling cookies may affect the functionality of parts of this website.",
          ],
        },
      ]}
    />
  );
}
